export default {
  occurrenceUnit: 'výskyt | výskyty',
};
